import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "0326585a-6aca-4c81-99c9-56dca0ee43f3",
    content: "Configuration 1",
    options: {
      image: `${config.ASSETS_URL}/05/14/task/task-1-item-1.svg`,
    },
  },
  {
    id: "0464a1d6-80d5-4eff-afcc-a3bccffb9f1f",
    content: "Configuration 2",
    options: {
      image: `${config.ASSETS_URL}/05/14/task/task-1-item-2.svg`,
    },
  },
  {
    id: "73435961-baae-4834-aeae-1e4b18541aa9",
    content: "Configuration 3",
    options: {
      image: `${config.ASSETS_URL}/05/14/task/task-1-item-3.svg`,
    },
  },
  {
    id: "f7210597-4702-413b-84a4-bafaecfec6d1",
    content: "Configuration 4",
    options: {
      image: `${config.ASSETS_URL}/05/14/task/task-1-item-4.svg`,
    },
  },
];

// TODO: Allow to connect items with a multiple groups
export const task: Task = {
  id: "8e370bc4-c68e-458e-8694-1b25e3ba28a0",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["f7210597-4702-413b-84a4-bafaecfec6d1"],
};
